module.exports = __webpack_public_path__ + "img/dmitriy.2f81b434.png";